<script>
export default {
  props: {
    id: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      open: false,
    }
  },
  methods: {
    collapseIsOpen() {
      return this.open;
    },

    openCollapse() {
      return new Promise((resolve) => {
        let collapse = bootstrap.Collapse.getOrCreateInstance(this.$refs.collapse);
        collapse.show();
        this.$refs.collapse.addEventListener('shown.bs.collapse', event => {
          this.open = true;
          resolve(true);
        })
      });
    },

    closeCollapse() {
      return new Promise((resolve) => {
        let collapse = bootstrap.Collapse.getOrCreateInstance(this.$refs.collapse);
        collapse.hide();
        this.$refs.collapse.addEventListener('hidden.bs.collapse', event => {
          this.open = false;
          resolve(true);
        })
      });
    }
  }
}
</script>

<template>
  <div ref="collapse" :id="id" class="collapse">
    <slot></slot>
  </div>
</template>